import React from "react";
import { useTranslation } from "react-i18next";

const STEP_KEYS = ["service", "staff", "time", "details", "payment"];

/**
 * Slim progress indicator for the booking wizard.
 * `step` is the same zero-based index MakeBooking.js uses for goSteps.
 */
const BookingStepper = ({ step }) => {
  const { t } = useTranslation("makeBooking");
  const total = STEP_KEYS.length;
  const current = Math.min(Math.max(step, 0), total - 1);
  const progressPct = (current / (total - 1)) * 100;

  return (
    <nav
      className="mb-stepper"
      aria-label={t("progress.ariaLabel")}
      style={{ "--mb-progress": `${progressPct}%` }}
    >
      <ol className="mb-stepper__track">
        {STEP_KEYS.map((key, idx) => {
          const status =
            idx < current ? "done" : idx === current ? "current" : "upcoming";
          return (
            <li
              key={key}
              className={`mb-stepper__step is-${status}`}
              aria-current={status === "current" ? "step" : undefined}
            >
              <span className="mb-stepper__marker" aria-hidden="true">
                {status === "done" ? "✓" : idx + 1}
              </span>
              <span className="mb-stepper__label">
                {t(`progress.steps.${key}`)}
              </span>
            </li>
          );
        })}
      </ol>

      <div className="mb-stepper__compact">
        <div className="mb-stepper__bar">
          <span className="mb-stepper__barFill" />
        </div>
        <p className="mb-stepper__compactLabel">
          {t("progress.stepOf", { current: current + 1, total })}
          <strong> · {t(`progress.steps.${STEP_KEYS[current]}`)}</strong>
        </p>
      </div>
    </nav>
  );
};

export default BookingStepper;
